import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { CheckCircleIcon } from '../../../../../components/icon/solid';
import { selectUploadMediaById } from '../../../../../store/modules/articles/selectors';
import { UploadContext } from '../../useUploadFiles';
import Progress from '../../upload-panel/Progress';
import { MediaStyles } from './styles';
import {Grid} from "@material-ui/core";

type Props = {
  articleId: number;
};

const UploadProgress = ({ articleId }: Props) => {
  const classes = MediaStyles();
  const { files } = useContext(UploadContext);
  const uploadMedia = useSelector(selectUploadMediaById(articleId));

  if (uploadMedia) {
    const currentFile = files.find((item) => item.meta.id === uploadMedia.uploadId);
    if (currentFile) {
      const { percent, status } = currentFile.meta;

      if (percent >= 100 && status === 'done') {
        return (
          <Grid item>
            <CheckCircleIcon className={classes.completeIcon} />
          </Grid>
        );
      }
      return (
        <Grid item style={{ margin: '0px 10px' }}>
          <Progress
            isStatic={currentFile?.isChunk || false}
            value={percent}
          />
        </Grid>
      );
    }
  }

  return null;
};

export default UploadProgress;
